import { LinkProps, Link as RemixLink } from "@remix-run/react";
import clsx from "clsx";
import { Link as ILink } from "~/sanity/types";
import { PropsWithChildren } from "react";

export type ILinkProps = {
  className?: string;
  slug?: string;
  to?: LinkProps["to"];
  onClick?: () => void;
} & ILink &
  PropsWithChildren;

export const Link = ({
  children,
  className,
  type = "internal",
  newTab = false,
  onClick,
  ...props
}: ILinkProps) => {
  const { slug, to } = props;

  return type === "internal" ? (
    <RemixLink
      onClick={onClick}
      prefetch="intent"
      className={clsx(className)}
      to={to || slug || ""}
      target={newTab ? "_blank" : ""}
    >
      {children}
    </RemixLink>
  ) : (
    <a className={clsx(className)} href={slug} target={newTab ? "_blank" : ""}>
      {children}
    </a>
  );
};

export default Link;
